import React from "react";
import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import Reversecoding from "../../assets/event-images/reversecoding.jpg";

const tikTik = {
  image: Reversecoding,
  description:
    "A thrilling 3-round competition that combines technical prowess, problem-solving, and detective skills to test your brainpower and teamwork. Each round brings unique challenges, and the cumulative score will determine the ultimate winner.",
  type: "Technical Event",
  eventName: "Tik Tik Tik",
  dateTime: "March 01, 10:30AM - 12:30AM",
  venue: "IT-443",
  rules: [
   "Round 1: The Brain Teaser - A Quizizz quiz on logic, tech, and general knowledge. Top performers move to the next round.",
"Round 2: The Code Breaker - 1v1 team battle to crack passwords, which contains a series of tasks. The team that cracks the password round moves forward.",
"Round 3: The Detective Challenge - Solve the 'Death Board' mystery using puzzles and clues.",
"Team Size: 2-3 members.",
"Rules: Judges' decisions are final.",
"The team with the highest score wins!"
],
  firstprize: 5000,
  secondprize: 2000,
  thirdprize: 0,
  contact: [
    {
      name: "Ranjit T N",
      phoneNo: "9843826655",
    },
    {
      name: "Dhanya Rithika ",
      phoneNo: "9442614014",
    },
  ],
};

const Tiktiktik = () => {
  return <SingleEventPage eventDetails={tikTik} />;
};

export default Tiktiktik;
